// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cald-modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.green-color {
  color: green;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/metric-modal/metric-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".cald-modal-body{\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.green-color{\n    color: green;;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
